import React from 'react'
import { usePaginationFragment, useFragment, graphql } from 'react-relay'

import { useMedia } from 'tamagui'
import { EventList } from '@newComponents'

import { GuildEventsUpcomingCard_guild$key } from './__generated__/GuildEventsUpcomingCard_guild.graphql'
import { GuildEventsUpcomingCard_query$key } from './__generated__/GuildEventsUpcomingCard_query.graphql'

export const GuildEventsUpcomingCard = ({
  guild,
  query,
}: {
  guild: GuildEventsUpcomingCard_guild$key
  query: GuildEventsUpcomingCard_query$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildEventsUpcomingCard_guild on Guild
      @refetchable(queryName: "GuildEventsUpcomingCardPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        upcomingEvents: eventsByTimeSelection(
          first: $count
          after: $cursor
          timeSelection: UPCOMING
          orderBy: [START_AT_ASC, ID_ASC]
        ) @connection(key: "GuildEventsUpcomingCard_guild_upcomingEvents") {
          edges {
            cursor
          }

          ...EventList_eventsConnection
        }
      }
    `,
    guild
  )

  const queryData = useFragment(
    graphql`
      fragment GuildEventsUpcomingCard_query on Query {
        ...EventList_query
      }
    `,
    query
  )

  const media = useMedia()

  return (
    <EventList
      eventsConnection={data.upcomingEvents}
      query={queryData}
      hasNext={hasNext}
      loadNext={loadNext}
      forceVertical={media.md}
    />
  )

  // return (
  //   <YStack gap='$4'>
  //     {/* <XStack gap='$4' alignItems='center'> */}
  //     {/* <H2>Upcoming Events</H2> */}

  //     {/* <Separator borderColor='$grey4' />
  //     </XStack> */}
  //     {/* <Stack direction='horizontal' gap={4} alignItems='center'>
  //       <Text size={4} variant='cardHeading'>
  //         Upcoming Events
  //       </Text>

  //       <HorizontalLine variant='cardHeading' />
  //     </Stack> */}

  //     <EventList
  //       eventsConnection={data.upcomingEvents}
  //       query={queryData}
  //       hasNext={hasNext}
  //       loadNext={loadNext}
  //     />
  //     {/*
  //     {data.upcomingEvents.edges.map((edge) => {
  //       return (
  //         <EventItem key={edge.cursor} event={edge.node} query={queryData} />
  //       )
  //     })}

  //     {hasNext && (
  //       <Button
  //         variant='secondary'
  //         hoverVariant='secondaryHover'
  //         onPress={() => {
  //           if (isLoadingNext) {
  //             return
  //           }

  //           loadNext(3)
  //         }}
  //       >
  //         <Text variant='buttonSecondary' size={4}>
  //           {isLoadingNext ? 'Loading...' : 'More'}
  //         </Text>
  //       </Button>
  //     )} */}
  //   </YStack>
  // )
}
